/**
 * Authentication configuration for prest0
 */
import { validateClientId } from '../utils/oauthDiagnostic';
import { STORAGE_KEYS } from '../constants';
import { purgeThreadCache } from '../components/GlobalChatSystem/threadPersist';

// SECURITY: Google OAuth Configuration - from environment variable only
const RAW_GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;
if (!RAW_GOOGLE_CLIENT_ID) {
  console.error('Missing required environment variable: REACT_APP_GOOGLE_CLIENT_ID');
}

// Use the diagnostic utility to validate the client ID
export const GOOGLE_CLIENT_ID = validateClientId(RAW_GOOGLE_CLIENT_ID || '');

// Authentication storage key
export const AUTH_STORAGE_KEY = STORAGE_KEYS.AUTH_TOKEN;

// Supported callback routes for OAuth
export const OAUTH_CALLBACK_ROUTES = [
  '/auth/callback/google',
  '/callback/google',
  '/auth/google/callback'
];

/**
 * Helper function to check if a user is authenticated
 * This is deprecated - use useAuth() hook from AuthContext instead
 * @returns boolean indicating if the user is authenticated
 */
export const isAuthenticated = (): boolean => {
  const token = localStorage.getItem(AUTH_STORAGE_KEY);
  return !!token;
};

/**
 * Stores authentication token in localStorage
 * @param token The authentication token to store
 */
export const storeAuthToken = (token: string): void => {
  localStorage.setItem(AUTH_STORAGE_KEY, token);

  // Dispatch an event so other components can react to auth state changes
  window.dispatchEvent(new CustomEvent('auth-state-changed', { 
    detail: { isAuthenticated: true }
  }));
};

/**
 * Clears the authentication token from localStorage
 */
export const clearAuthToken = (): void => {
  localStorage.removeItem(AUTH_STORAGE_KEY);
  purgeThreadCache();
  
  // Dispatch an event so other components can react to auth state changes
  window.dispatchEvent(new CustomEvent('auth-state-changed', { 
    detail: { isAuthenticated: false }
  }));
}; 
